import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';
import AccountLogo from '../../modules/Feedback/components/account-logo';
import ProgressBar from '../progress-bar';
import { loadContact } from './actions';
import ContactNameRenderer from '../table-cells/ContactNameRenderer';
import AccountNameRenderer from '../table-cells/AccountNameRenderer';

class OwnerCell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loaded: false,
      errors: null,
      contact: props.contact,
      account: props.account,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    if (this.state.loading) {
      return;
    }
    this.setState({ loading: true, loaded: false }, () => {
      loadContact(this.props.contact.contact_id)
      .then(
        ({ contact, account }) => {
          this.setState({ contact: { ...this.props.contact, ...contact }, account, loading: false, loaded: true });
        },
        (errors) => {
          this.setState({ loading: false, errors });
        },
      );
    });
  }

  renderLogo() {
    const {
      account,
    } = this.state;

    if (!account) {
      return null;
    }

    return (
      <div className="pull-left">
        <div className={styles.logo}>
          <AccountLogo account={account} />
        </div>
      </div>
    );
  }

  renderContent() {
    const {
      contact,
      account,
    } = this.state;

    if (!contact) {
      return null;
    }

    const isHashed = contact.is_hashed;

    let accountCmp = null;
    if (account) {
      accountCmp = (
        <tr>
          <th>Account:</th>
          <td>
            <AccountNameRenderer data={account} value={`${account.name}`} />
          </td>
        </tr>
      );
    }

    return (
      <div>
        <div className={`${styles.header} clearfix`}>
          {!isHashed && this.renderLogo()}
          <div className={styles.heading}>
            <div>
              <div>
                <ContactNameRenderer data={contact} value={`${contact.first_name} ${contact.last_name}`} />
                {!contact.is_primary && ' '}
                {!contact.is_primary && <span className="label label-warning">Primary</span>}
              </div>
              {contact.title !== null && contact.title.length > 0 && <div>{contact.title}</div>}
              {contact.role !== null && contact.role.length > 0 ? <div>{contact.role}</div> : <div><em>No role</em></div>}
            </div>
          </div>
        </div>
        <div className={styles.body}>
          <table className="table table-condensed" style={{ margin: 0 }}>
            <tbody>
              {accountCmp}
              <tr>
                <th>Email:</th>
                <td>
                  {contact.email && contact.email.length > 0 ? <a href={`mailto:${contact.email}`}>{contact.email}</a> : 'N/A'}
                </td>
              </tr>
              <tr>
                <th>Phone:</th>
                <td>{(contact.phone && contact.phone.length > 0 ? contact.phone : 'N/A')}</td>
              </tr>
              <tr>
                <th>Mobile:</th>
                <td>{(contact.mobile_phone && contact.mobile_phone.length > 0 ? contact.mobile_phone : 'N/A')}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderLoading() {
    return (
      <div>
        <p />
        <ProgressBar />
        <p />
      </div>
    );
  }

  renderErrors() {
    return (
      <div className="alert alert-danger">
        Please try again.
      </div>
    );
  }

  render() {
    const { 
      loading, loaded,
    } = this.state;
    if (loading) {
      return this.renderLoading();
    }
    if (!loaded) {
      return this.renderErrors();
    }
    return this.renderContent()
  }
}

OwnerCell.propTypes = {
  contact: PropTypes.shape({
    contact_id: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
  }),
};
OwnerCell.defaultProps = {
  account: null,
};
OwnerCell.contextTypes = {
};


export default OwnerCell;
